import AuditsCard from "@components/AuditsCard";
import usePageData from "@hooks/usePageData";

const Audits = () => {
  const auditsData =
    usePageData(
      "$.page.data.right_sections.data[?(@.attributes.key=='audits')]"
    )[0]?.attributes || {};

  const audits = usePageData("$.page.data.audits")[0];
  const { action_cta, action_link } = audits || {};

  return (
    <AuditsCard
      title={auditsData?.title}
      subTitle={auditsData?.sub_title}
      auditsData={audits?.audits_data || []}
      actionCTA={action_cta}
      actionLink={action_link}
    />
  );
};

export default Audits;
